import {useGlobalContext} from "../context/GlobalState";
import {ReviewStateEnum, ToCurrency} from "../services/Utils";
import {Box, CircularProgress, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import React, {useEffect, useState} from "react";

const styles = {
    container: {
        background: "white",
        borderRadius: 1,
        padding: 1,
        height: "100%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        flexDirection: "column",
        boxSizing: "border-box",
        backgroundColor: "primary.componentbg",
    },
    checkTotalsBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        position: "relative"
    },
    datePickerBox: {
        display: "flex",
        flexDirection: "row",
        textAlign: "center",
        marginTop: 2,
        gap: 1,
    },
    checkTotalBox: {
        textAlign: "center",
        margin: 0,
    },
    reviewStateBox: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
    },
};

function CheckTotalBox({reviewState}) {
    const {dashData} = useGlobalContext();
    const theme = useTheme();
    const getReviewStateId =
        reviewState === "Pending" ? ReviewStateEnum.Pending
            : reviewState === "Approved" ? ReviewStateEnum.Approved
                : reviewState === "Rejected" ? ReviewStateEnum.Rejected :
                    null;
    // Get the total amount of all checks that are in the reviewState with total starting at 0
    const total = dashData?.reduce(
        (acc, check) =>
            !reviewState || check.reviewStateId === getReviewStateId
                ? acc + Number(check.depositTotal)
                : acc,
        0
    ) ?? 0;

    const borderColor =
        reviewState === "Pending"
            ? theme.palette.primary.main
            : reviewState === "Approved"
                ? theme.palette.accent.success
                : reviewState === "Rejected"
                    ? theme.palette.accent.error
                    : "transparent";

    return (
        <Box m={1}>
            <Typography
                variant={reviewState ? "h5" : "h3"}
                sx={{
                    border: 1,
                    borderRadius: 1,
                    borderColor: borderColor,
                    padding: 1,
                    backgroundColor: !reviewState ? "transparent" : "primary.background",
                    color: "primary.main",
                }}
            >
                {ToCurrency(total)}
            </Typography>
            <Typography variant="subtitle2">{reviewState}</Typography>
        </Box>
    );
}

export function CheckTotals() {
    const {dashData} = useGlobalContext();
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        setLoading(!dashData);
    }, [dashData]);

    return (
        <Box sx={styles.container} boxShadow={3}>
            <Typography variant="h5" alignSelf="flex-start">
                Totals by Review Status
            </Typography>
            <Box title="Check Totals" sx={styles.checkTotalsBox}>
                {loading && (
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "primary.componentbg",
                            opacity: 0.7,
                            zIndex: 1
                        }}
                    >
                        <CircularProgress/>
                    </Box>
                )}
                <Box sx={styles.checkTotalBox}>
                    <CheckTotalBox/>
                </Box>
                <Box sx={styles.reviewStateBox}>
                    <CheckTotalBox reviewState="Pending"/>
                    <CheckTotalBox reviewState="Approved"/>
                    <CheckTotalBox reviewState="Rejected"/>
                </Box>
            </Box>
        </Box>
    );
}
